<script lang="tsx" setup>
import { computed } from "vue";

type Props = {
  level?: "1" | "2" | "3" | "4" | "5" | "6";
};
const props = defineProps<Props>();
const level = computed(() => `h${props.level ?? "1"}`);
</script>
<template>
  <component :is="level" class="text-primary-800 dark:text-primary-300">
    <slot />
  </component>
</template>
